var angular = require('angular');

function DriverUser(user) {
  angular.extend(this, user);
}

DriverUser.prototype.editClone = function() {
  var user = {};

  var props = ['userName', 'firstName', 'lastName', 'phone', 'email', 'active', 'lastLoggedIn', 'language'];

  props.forEach(function(prop) {
    user[prop] = this[prop];
  }, this);

  return user;
};

module.exports = DriverUser;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/driverUser.js
 ** module id = 173
 ** module chunks = 1
 **/